import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { RedisModule } from 'src/redis/redis.module';
import { ReferencialesService } from './referenciales.service';
import { ReferencialesController } from './referenciales.controller';

@Module({
  imports: [PrismaModule, RedisModule],
  controllers: [ReferencialesController],
  providers: [ReferencialesService],
})
export class ReferencialesModule {}
